import { Component, OnInit, OnDestroy, Input, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, CredentialsService } from '@app/auth';
// import { SearchService } from 'src/services/search-service.service';
import { SearchService } from '../../../services/search-service.service';
//import { ProductService } from 'src/services/productservice';
import { ProductService } from '../../../services/productservice';
import { MessageService } from 'primeng/api';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { environment } from '@env/environment';
// import { PostMessageService } from 'src/services/post-message.service';
import { PostMessageService } from '../../../services/post-message.service';
// import { AuthDialogService } from 'src/services/auth-dialog.service';
import { AuthDialogService } from '../../../services/auth-dialog.service';

declare var $: any;

@Component({
  selector: 'app-legacy-header',
  templateUrl: './legacy-header.component.html',
  styleUrls: ['./legacy-header.component.scss'],
  providers: [MessageService],
})
export class LegacyHeaderComponent implements OnInit, OnDestroy {
  menuHidden = true;
  @Input() item: string;
  menuitem: string = 'MENU';
  headermenu: any;
  sildemenu: any;
  menuname: any;
  public user: any;
  public searchSub: Subscription = null;
  public searchDetails: any = {};
  public results: any[];
  public refFilterResult: any = [];
  public searchItems: any;
  public searchResults: any;
  public suggestionsText: any;
  public isShow = true;
  public popularKeywords: any = [];
  userLetter: any;
  public newserachResults: any = [];
  public modelPopUp = false;
  public textEnter: string;
  headerLogo: any = { name: null, icon: null, url: null };
  profileDialogue: boolean;
  userAccountDeleteDialogue: boolean = false;
  accountDeleteReasons: any[] = [];
  userMail: any;
  userCountry: any;
  changePasswordDialogue: boolean;
  changePasswordForm: FormGroup;
  username: any;
  userid: any;
  fieldOldPasswordType: boolean;
  fieldNewPasswordType: boolean;
  fieldConfirmPasswordType: boolean;
  totalWishlistCount: any = 0;
  changeUserNameForm: FormGroup;
  accountDeleteForm: FormGroup;
  public showUsername: boolean = false;
  public showUserCountry: boolean = false;
  userProfile: any;
  currentUser: any;
  confirmMessage: any;
  confirmMessageSummary: any;
  isLoading = false;
  error: string | undefined;
  //current_user:User;
  public searchQuery: any;
  language: string;
  loginDialogue: boolean;
  private authSubscription: Subscription;
  loginForm!: FormGroup;
  fieldPasswordType: boolean;
  forgotPasswordDialogue: boolean;
  forgotPassForm: FormGroup;
  registrationDialog: boolean;
  registerForm: any;
  isSuccessful: boolean;
  isSignUpFailed: boolean;
  errorMessage: any;
  subscribeRes: any;
  resetPasswordDialog: boolean;
  resetPasswordForm!: FormGroup;
  fieldTempPasswordType: boolean;
  selectedCountry: any = {};
  countries: any = [];
  verifiationFailed: boolean = false;
  messages: any = [];
  //blocked: boolean;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private credentialsService: CredentialsService,
    private searchService: SearchService,
    private messageService: MessageService,
    private productService: ProductService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private titleService: Title,
    private postMessageService: PostMessageService,
    private authDialogService: AuthDialogService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentUser) {
      // authorised so return true
      this.getUserProfile();
    }
  }

  countrySelected() {}

  ngOnInit() {
    console.log('LegacyHeaderComponent loaded');
    this.chatbotRegisterClick();
    //Get selected language
    this.language = localStorage.getItem('language');
    this.getCountries();
    this.productService.getFooterLogo().then((result) => {
      this.headerLogo = result[0];
    });
    this.totalWishlistCount = localStorage.getItem('totalWishlistCount')
      ? localStorage.getItem('totalWishlistCount')
      : 0;

    this.productService.getPopularSearchKeywords(this.language).then((res) => {
      this.popularKeywords = res;
    });

    // Subscribe to authentication state changes
    this.authSubscription = this.authenticationService.currentUser.subscribe((user) => {
      this.currentUser = user;
      if (this.currentUser) {
        this.getUsername();
        this.getUserProfile();
      } else {
        this.username = null;
        this.userLetter = null;
      }
    });

    // if (location.pathname.indexOf('user-activation') > -1) {
    //   this.productService.activateUser(location.search).then((res) => {
    //     this.authDialogService.setVerificationFailed(true);
    //     this.showLoginDialog();
    //   });
    // }
    if (location.pathname.indexOf('user-activation') > -1) {
      this.productService
        .activateUser(location.search)
        .then((res) => {
          if (res?.success == 200) {
            this.authDialogService.setVerificationFailed(false);
          } else {
            this.authDialogService.setVerificationFailed(true);
          }
          this.showLoginDialog();
        })
        .catch(() => {
          this.authDialogService.setVerificationFailed(true);
          this.showLoginDialog();
        });
    }

    //Moile Menu
    this.sildemenu = [
      {
        islands: [
          {
            title: 'The Islands',
            route: 'experience',
            routeParam: 'theislands',
            url: 'experience/theislands',
            cat: 'DESTINFO',
            cla: 'ISLANDS',
            bannerCat: 'islands',
          },
        ],
      },
      {
        planyourvisit: [
          {
            title: 'Plan Your Visit',
            items: [
              {
                title: 'Accommodations',
                route: 'planyourvisit',
                routeParam: 'wheretostay',
                url: 'planyourvisit/wheretostay',
                cat: 'ACCOMM',
                cla: '',
              },
              // {
              //   title: 'Itinerery Ideas',
              //   url: 'planyourvisit',
              // },
              // {
              //   title: 'Best time to visit',
              //   url: 'planyourvisit',
              // },
              {
                title: 'Tour Operators',
                route: 'planyourvisit',
                routeParam: 'touroperators',
                url: 'planyourvisit/touroperators',
                cat: 'TOUROPERATOR',
                cla: '',
              },
              {
                title: 'About Seychelles',
                image: 'inner-island-thumb-1.jpg',
                route: 'aboutus',
                routeParam: 'aboutseychelles',
                url: 'aboutus/aboutseychelles',
              },
              {
                title: 'Getting Around',
                image: 'plan-visit-thumb-5.jpg',
                route: 'planyourvisit',
                routeParam: 'gettingaround',
                url: 'planyourvisit/gettingaround',
                cla: 'BICYCLE,BOAT,CAR,DOMAIRSVC,EQUIP,MINBUSCOAC,YACHT,BUSSVC,COACHSVC,FERRYSVC,TAXI',
                bannerCat: 'getting-around',
              },
              {
                title: 'Travel Information',
                image: 'inner-island-thumb-1.jpg',
                route: 'travelinfo',
                routeParam: 'travelinformation',
                url: 'travelinfo/travelinformation',
              },

              {
                title: 'Airlines',
                image: 'plan-visit-thumb-4.jpg',
                route: 'planyourvisit',
                routeParam: 'airlines',
                url: 'planyourvisit/airlines',
                cat: 'TRANSPORT',
                //cat:'&cats=TRANSPORT' + '&cla=AIR',
                cla: 'INTAIRSVC',
              },
            ],
          },
        ],
      },
      {
        experience: [
          {
            title: 'Experience',
            items1: [
              {
                title: 'Activities',
                image: 'expirence-thumb-2.jpg',
                route: 'experience',
                routeParam: 'activities',
                url: 'experience/activities',
                cat: 'TOUR',
                bannerCat: 'activity',
                cla: '',
              },

              {
                title: 'General Services',
                route: 'experience',
                routeParam: 'generalservices',
                url: 'experience/generalservices',
                cat: 'GENSERVICE',
                cla: '',
                bannerCat: '',
              },
              {
                title: 'Food & Drinks',
                route: 'experience',
                routeParam: 'food-drinks',
                url: 'experience/food-drinks',
                cat: 'RESTAURANT',
                cla: '',
              },
              {
                title: 'Walks & Trails',
                image: 'expirence-thumb-4.jpg',
                route: 'experience',
                routeParam: 'walksandtrails',
                url: 'experience/walksandtrails',
                cla: 'WBTOURS,TRAIL',
                bannerCat: 'walks-trails',
              },

              {
                title: 'Attractions',
                image: 'expirence-thumb-1.jpg',
                route: 'experience',
                routeParam: 'attractions',
                url: 'experience/attractions',
                cat: 'ATTRACTION',
                cla: '',
              },
              {
                title: 'Events',
                route: 'experience',
                routeParam: 'events',
                url: 'experience/events',
                cat: 'EVENT',
                cla: '',
              },
            ],
            items2: [
              {
                title: 'Sailing',
                url: 'special_interest/sailing',
                image: 'expirence-thumb-4.jpg',
              },
              {
                title: 'Fishing',
                image: 'expirence-thumb-1.jpg',
                url: 'special_interest/fishing',
              },
              {
                title: 'Romance',
                url: 'special_interest/romance',
                image: 'expirence-thumb-4.jpg',
              },
              {
                title: 'Diving',
                image: 'expirence-thumb-1.jpg',
                url: 'special_interest/diving',
              },
              {
                title: 'Nature',
                image: 'nature_menu.avif',
                url: 'special_interest/nature',
              },
              {
                title: 'Culture',
                image: 'culture_menu.avif',
                url: 'special_interest/culture',
              },
              {
                title: 'Sustainable Seychelles',
                image: 'expirence-thumb-1.jpg',
                url: 'special_interest/sustainable_seychelles',
              },
            ],
          },
        ],
      },
      {
        userDropdown: [
          {
            title: this.username,
            items: [
              {
                title: 'Profile',
                url: '',
              },
              {
                title: 'Change Password',
                url: '',
              },
              {
                title: 'Logout',
                url: '',
              },
            ],
          },
        ],
      },
      {
        explore: [
          {
            title: 'Explore 360',
            url: 'explore-islands/overview',
            /*search: {
              title: 'Search By Regions',
            },
            overview: {
              title: 'See Overview',
              route: 'explore-islands',
              routeParam: 'overview',
              url: 'explore-islands/overview',
            },
            items: [],*/
          },
        ],
      },
    ];

    //Header Menu(Desktop)
    this.headermenu = [
      {
        headerlog: [
          {
            logo: 'seychellesnew.png',
            url: '',
          },
        ],
        headeritems: [
          {
            item: [
              {
                title: 'The Islands',
                route: 'experience',
                routeParam: 'theislands',
                url: 'experience/theislands',
                cat: 'DESTINFO',
                cla: 'ISLANDS',
                bannerCat: 'islands',
              },
            ],
            item4: [
              {
                title: 'Explore in 360',
                url: 'explore-islands/overview',
                route: 'explore-islands',
                routeParam: 'overview',
                /*search: {
                  title: 'Search By Regions',
                },
                overview: {
                  title: 'See Overview',
                  route: 'explore-islands',
                  routeParam: 'overview',
                  url: 'explore-islands/overview',
                },*/
                row: [],
              },
            ],
            item2: [
              {
                title: 'Plan Your Visit',
                row1: [
                  {
                    title: 'Accommodations',
                    image: '../../../assets/images/Accomm_Menu_icon.png',
                    route: 'planyourvisit',
                    routeParam: 'wheretostay',
                    url: 'planyourvisit/wheretostay',
                    rel: 'canonical',
                    cat: 'ACCOMM',
                    cla: '',
                  },

                  {
                    title: 'Tour Operators',
                    image: '../../../assets/images/TourOperator_menu_icon.png',
                    route: 'planyourvisit',
                    routeParam: 'touroperators',
                    url: 'planyourvisit/touroperators',
                    cat: 'TOUROPERATOR',
                    cla: '',
                  },
                  {
                    title: 'About Seychelles',
                    image: '../../../assets/images/AboutSeychelles_menu_icon.png',
                    route: 'aboutus',
                    routeParam: 'aboutseychelles',
                    url: 'aboutus/aboutseychelles',
                  },
                ],
                row2: [
                  {
                    title: 'Getting Around',
                    image: '../../../assets/images/Getting_Around_menu_icon.png',
                    route: 'planyourvisit',
                    routeParam: 'gettingaround',
                    url: 'planyourvisit/gettingaround',
                    cla: 'BICYCLE,BOAT,CAR,DOMAIRSVC,EQUIP,MINBUSCOAC,YACHT,BUSSVC,COACHSVC,FERRYSVC,TAXI',
                    bannerCat: 'getting-around',
                  },
                  {
                    title: 'Travel Information',
                    image: '../../../assets/images/Travel_Info_menu_icon.png',
                    route: 'travelinfo',
                    routeParam: 'travelinformation',
                    url: 'travelinfo/travelinformation',
                  },

                  {
                    title: 'Airlines',
                    image: '../../../assets/images/Airlines_menu_icon.png',
                    route: 'planyourvisit',
                    routeParam: 'airlines',
                    url: 'planyourvisit/airlines',
                    cat: 'TRANSPORT',
                    //cat:'&cats=TRANSPORT' + '&cla=AIR',
                    cla: 'INTAIRSVC',
                  },
                ],
                about: [
                  {
                    option1: [
                      {
                        title: 'About Us',
                        image: 'inner-island-thumb-1.jpg',
                        url: '',
                      },
                    ],
                    links: [
                      {
                        title: 'Culture',
                        url: '',
                      },
                      {
                        title: 'Climate',
                        url: '',
                      },
                      {
                        title: 'Geography',
                        url: '',
                      },
                      {
                        title: 'History',
                        url: '',
                      },
                      {
                        title: 'Society',
                        url: '',
                      },
                    ],
                  },
                ],
                travelInfo: [
                  {
                    option1: [
                      {
                        title: 'Travel Info',
                        image: 'inner-island-thumb-1.jpg',
                        route: 'travelinfo',
                        routeParam: 'travelinformation',
                        url: 'travelinfo/travelinformation',
                      },
                    ],
                    links: [
                      {
                        title: 'Travel Essentials',
                        url: 'travel-essentials',
                      },
                      {
                        title: 'Travel Advisory',
                        url: 'travel-advisory',
                      },
                      {
                        title: 'Best time to visit',
                        url: 'best-time-visit',
                      },
                      {
                        title: 'General services',
                        route: 'planyourvisit',
                        routeParam: 'generalservices',
                        url: 'planyourvisit/generalservices',
                        cat: 'GENSERVICE',
                      },
                      {
                        title: 'Information services',
                        route: 'planyourvisit',
                        routeParam: 'informationservices',
                        url: 'planyourvisit/informationservices',
                        cat: 'INFO',
                      },
                    ],
                  },
                ],
                gettingaround: [
                  {
                    subtitle: 'getting Around',
                    option2: [
                      {
                        title: 'Getting Around',
                        image: 'plan-visit-thumb-5.jpg',
                        route: 'planyourvisit',
                        routeParam: 'gettingaround',
                        url: 'planyourvisit/gettingaround',
                        cla: 'BICYCLE,BOAT,CAR,DOMAIRSVC,EQUIP,MINBUSCOAC,YACHT,BUSSVC,COACHSVC,FERRYSVC,TAXI',
                        bannerCat: 'getting-around',
                      },
                    ],
                    links: [
                      {
                        title: 'Rentals',
                        route: 'planyourvisit',
                        routeParam: 'rentals',
                        url: 'planyourvisit/rentals',
                        cat: 'HIRE',
                        cla: '',
                        bannerCat: 'getting-around',
                      },
                      {
                        title: 'Ferries',
                        route: 'planyourvisit',
                        routeParam: 'ferries',
                        url: 'planyourvisit/ferries',
                        cat: 'TRANSPORT',
                        cla: 'FERRYSVC',
                        bannerCat: 'getting-around',
                      },
                      {
                        title: 'Domestic Flights',
                        route: 'planyourvisit',
                        routeParam: 'domesticflights',
                        url: 'planyourvisit/domesticflights',
                        cat: 'TRANSPORT',
                        cla: 'AIRSVC',
                        bannerCat: 'getting-around',
                      },
                      {
                        route: 'planyourvisit',
                        routeParam: 'coachservices',
                        url: 'planyourvisit/coachservices',
                        title: 'Coach Services',
                        cat: 'TRANSPORT',
                        cla: 'COACHSVC',
                        bannerCat: 'getting-around',
                      },
                      {
                        title: 'Buses',
                        route: 'planyourvisit',
                        routeParam: 'buses',
                        url: 'planyourvisit/buses',
                        cat: 'TRANSPORT',
                        cla: 'BUSSVC',
                        bannerCat: 'getting-around',
                      },
                      {
                        title: 'Taxis',
                        route: 'planyourvisit',
                        routeParam: 'taxis',
                        url: 'planyourvisit/taxis',
                        cat: 'TRANSPORT',
                        cla: 'TAXI',
                        bannerCat: 'getting-around',
                      },
                    ],
                  },
                ],
              },
            ],
            item3: [
              {
                title: 'Experience',
                row1: [
                  {
                    title: 'Activities',
                    image: '../../../assets/images/Activities_menu_icon.png',
                    route: 'experience',
                    routeParam: 'activities',
                    url: 'experience/activities',
                    cat: 'TOUR',
                    bannerCat: 'activity',
                    cla: '',
                  },
                  {
                    title: 'General Services',
                    image: '../../../assets/images/generalservices.png',
                    route: 'experience',
                    routeParam: 'generalservices',
                    url: 'experience/generalservices',
                    cat: 'GENSERVICE',
                  },
                  // {
                  //   title: 'Beaches',
                  //   image: '../../../assets/images/Beaches_menu_icon.png',
                  //   route: 'experience',
                  //   routeParam: 'beaches',
                  //   url: 'experience/beaches',
                  //   cat: 'DESTINFO',
                  //   cla: 'BEACHES',
                  //   bannerCat: 'beaches',
                  // },
                  {
                    title: 'Food & Drinks',
                    image: '../../../assets/images/Restaurents_menu_icon.png',
                    route: 'experience',
                    routeParam: 'food-drinks',
                    url: 'experience/food-drinks',
                    cat: 'RESTAURANT',
                    cla: '',
                  },
                ],
                row2: [
                  {
                    title: 'Walks & Trails',
                    image: '../../../assets/images/Walk_Trails_menu_icon.png',
                    route: 'experience',
                    routeParam: 'walksandtrails',
                    url: 'experience/walksandtrails',
                    cat: 'ATTRACTION',
                    cla: 'NATATTRACT',
                    tag: 'TAGWalks-Trails',
                    bannerCat: 'walks-trails',
                  },

                  {
                    title: 'Attractions',
                    image: '../../../assets/images/Attractions_menu_icon.png',
                    route: 'experience',
                    routeParam: 'attractions',
                    url: 'experience/attractions',
                    cat: 'ATTRACTION',
                    cla: '',
                  },
                  {
                    title: 'Events',
                    route: 'experience',
                    routeParam: 'events',
                    url: 'experience/events',
                    image: '../../../assets/images/Events_menu_icon.png',
                    cat: 'EVENT',
                    cla: '',
                  },
                ],
                row3: [
                  {
                    title: 'Sailing',
                    url: 'special_interest/sailing',
                    image: 'sailing_menu.avif',
                    // url: 'experience',
                    // cla: 'WBTOURS,TRAIL',
                    // bannerCat: 'walks-trails',
                  },
                  {
                    title: 'Fishing',
                    image: 'fishing_menu.avif',
                    url: 'special_interest/fishing',
                  },
                  {
                    title: 'Nature',
                    image: 'nature_menu.avif',
                    url: 'special_interest/nature',
                  },
                ],
                row4: [
                  {
                    title: 'Culture',
                    url: 'special_interest/culture',
                    image: 'culture_menu.avif',
                    // url: 'experience',
                    // cla: 'WBTOURS,TRAIL',
                    // bannerCat: 'walks-trails',
                  },
                ],
                row5: [
                  {
                    title: 'Romance',
                    url: 'special_interest/romance',
                    image: 'romance_menu.avif',
                  },
                  {
                    title: 'Diving',
                    image: 'diving_menu.avif',
                    url: 'special_interest/diving',
                  },
                ],
                row6: [
                  {
                    title: 'Sustainable Seychelles',
                    image: 'workcation_menu.avif',
                    url: 'special_interest/sustainable_seychelles',
                  },
                ],
                Activites: [
                  {
                    subtitle: 'Activities',
                    option1: [
                      {
                        title: 'Activities',
                        image: 'expirence-thumb-2.jpg',
                        route: 'experience',
                        routeParam: 'activities',
                        url: 'experience/activities',
                        cat: 'TOUR',
                        bannerCat: 'activity',
                        cla: '',
                      },
                    ],
                  },
                ],
                Atrractions: [
                  {
                    subtitle: 'Atrractions',
                    option2: [
                      {
                        title: 'Attractions',
                        image: 'expirence-thumb-1.jpg',
                        route: 'experience',
                        routeParam: 'attractions',
                        url: 'experience/attractions',
                        cat: 'ATTRACTION',
                        cla: '',
                      },
                    ],
                    links: [
                      {
                        title: 'Galleries, Museums and Collections',
                        route: 'experience',
                        routeParam: 'galleries',
                        url: 'experience/galleries',
                        cat: 'ATTRACTION',
                        cla: 'GALMUSECOL',
                      },
                      {
                        title: 'Parks and Gardens',
                        route: 'experience',
                        routeParam: 'parksandgardens',
                        url: 'experience/parksandgardens',
                        cat: 'ATTRACTION',
                        cla: 'PKGDNCEM',
                      },
                      {
                        title: 'Entertainment Venues',
                        route: 'experience',
                        routeParam: 'entertainmentvenues',
                        url: 'experience/entertainmentvenues',
                        cat: 'ATTRACTION',
                        cla: 'ENTERTAIN',
                      },
                      {
                        title: 'Historical Sites and Heritage Locations',
                        route: 'experience',
                        routeParam: 'historicalsites',
                        url: 'experience/historicalsites',
                        cat: 'ATTRACTION',
                        cla: 'HISTHERITG',
                      },
                      {
                        title: 'Landmarks and Buildings',
                        route: 'experience',
                        routeParam: 'landmarks',
                        url: 'experience/landmarks',
                        cat: 'ATTRACTION',
                        cla: 'LMARKBLD',
                      },
                      {
                        title: 'National parks & Reserves',
                        route: 'experience',
                        routeParam: 'nationalparks',
                        url: 'experience/nationalparks',
                        cat: 'ATTRACTION',
                        cla: 'NATPARKRES',
                      },
                      // {
                      //   title: 'Religious',
                      //   url: 'experience',
                      //   cat: 'ATTRACTION',
                      //   cla: '',
                      // },
                      // {
                      //   title: 'Uninesco world heritage sute',
                      //   url: 'experience',
                      //   cat: 'ATTRACTION',
                      //   cla: '',
                      // },
                      {
                        title: 'Amusement and Theme Parks',
                        route: 'experience',
                        routeParam: 'amusementparks',
                        url: 'experience/amusementparks',
                        cat: 'ATTRACTION',
                        cla: 'AMUSETHEME',
                      },
                      {
                        title: 'Natural Attraction',
                        route: 'experience',
                        routeParam: 'nationalattraction',
                        url: 'experience/nationalattraction',
                        cat: 'ATTRACTION',
                        cla: 'NATATTRACT',
                      },
                      {
                        title: 'Shopping and Markets',
                        route: 'experience',
                        routeParam: 'shoppingandmarkets',
                        url: 'experience/shoppingandmarkets',
                        cat: 'ATTRACTION',
                        cla: 'SHOPPING',
                      },
                      {
                        title: 'Spas and Retreats',
                        route: 'experience',
                        routeParam: 'spasandretreats',
                        url: 'experience/spasandretreats',
                        cat: 'ATTRACTION',
                        cla: 'SPARETREAT',
                      },
                      {
                        title: 'Sports and Recreation Facilities',
                        route: 'experience',
                        routeParam: 'sportsandrecreation',
                        url: 'experience/sportsandrecreation',
                        cat: 'ATTRACTION',
                        cla: 'SPORTREC',
                      },
                      {
                        title: 'Zoos, Sanctuaries, Aquariums and Wildlife Parks',
                        route: 'experience',
                        routeParam: 'zoosandwildlifeparks',
                        url: 'experience/zoosandwildlifeparks',
                        cat: 'ATTRACTION',
                        cla: 'ZOOSNCAQU',
                      },
                    ],
                  },
                ],
                Specialinterest: [
                  {
                    subtitle: 'Special Interest',
                    option3: [
                      {
                        title: 'Special Interest',
                        image: 'expirence-thumb-3.jpg',
                        url: 'special_interest',
                      },
                    ],
                    links: [
                      {
                        title: 'Culture',
                        url: 'special_interest/culture',
                      },
                      {
                        title: 'Nature',
                        url: 'special_interest/nature',
                      },
                      {
                        title: 'Sailing',
                        url: 'special_interest/sailing',
                      },
                      {
                        title: 'Romance',
                        url: 'special_interest/romance',
                      },
                      {
                        title: 'Fishing',
                        url: 'special_interest/fishing',
                      },
                      {
                        title: 'Diving',
                        url: 'special_interest/diving',
                      },
                    ],
                  },
                ],
                Walkstrails: [
                  {
                    subtitle: 'Walks & Trails',
                    option4: [
                      {
                        title: 'Walks & Trails',
                        image: 'expirence-thumb-4.jpg',
                        route: 'experience',
                        routeParam: 'walksandtrails',
                        url: 'experience/walksandtrails',
                        cla: 'WBTOURS,TRAIL',
                        bannerCat: 'walks-trails',
                      },
                    ],
                    links: [
                      {
                        title: 'Food & Drinks',
                        route: 'experience',
                        routeParam: 'food-drinks',
                        url: 'experience/food-drinks',
                        cat: 'RESTAURANT',
                        cla: '',
                      },
                      {
                        title: 'Beaches',
                        route: 'experience',
                        routeParam: 'beaches',
                        url: 'experience/beaches',
                        cat: 'DESTINFO',
                        cla: 'BEACHES',
                        bannerCat: 'beaches',
                      },
                      {
                        title: 'Events',
                        route: 'experience',
                        routeParam: 'events',
                        url: 'experience/events',
                        cat: 'EVENT',
                        cla: '',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
        headericons: [
          {
            sign: 'Sign In',
            signout: 'Logout',
            url: '',
            langdropdown: [
              {
                title: 'EN',
                lang: [
                  {
                    langtitle: 'English',
                    url: '',
                  },
                  {
                    langtitle: 'French',
                    url: '',
                  },
                  {
                    langtitle: 'Italian',
                    url: '',
                  },
                  {
                    langtitle: 'Chinese',
                    url: '',
                  },
                  {
                    langtitle: 'Portuguese',
                    url: '',
                  },
                  {
                    langtitle: 'Russian',
                    url: '',
                  },
                  {
                    langtitle: 'Spanish',
                    url: '',
                  },
                ],
              },
            ],
            icons: [
              {
                iconsname: 'icon icon-search-light',
                url: '',
                title: 'Search',
              },
              {
                iconsname: 'Sign In',
                url: '',
              },
            ],
          },
        ],
      },
    ];

    /*this.productService.get360Info().then((result) => {
      result.forEach((element: any) => {
        const json = {
          title: element.title,
          image: environment.adminBaseURL.toLowerCase() + '/' + element.field_banner_image,
          route: 'listingdetails',
          routeParam: element.field_listing_id,
          url: 'listingdetails/' + element.field_listing_id,
        };
        this.headermenu[0].headeritems[0].item4[0].row.push(json);
        this.sildemenu[4].explore[0].items.push(json);
      });
    });*/
  }
  private createForm() {
    //create/Build Login form
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: true,
    });
  }

  /**
   * togglePasswordType()
   * show and hide password when click on eye icon on password filed
   */
  togglePasswordType() {
    this.fieldPasswordType = !this.fieldPasswordType;
  }
  /**
   * onLoginSubmit
   * Submit the login form
   */

  onLoginSubmit() {
    this.authenticationService.login(this.loginForm.value).subscribe(
      (res: any) => {
        let item = 'temp_pass';
        if (res[item]) {
          this.messageService.add({
            key: 'login',
            severity: 'success',
            summary: this.translate.instant('Success'),
            detail: this.translate.instant('SignIn-Success'),
          });
          setTimeout(() => {
            this.showResetPasswordDialog();
            this.closeLoginDialog();
            // this.router.navigate(['/reset-password'], { relativeTo: this.route });
          }, 1000);
        } else {
          this.messageService.add({
            key: 'login',
            severity: 'success',
            summary: this.translate.instant('Success'),
            detail: this.translate.instant('SignIn-Success'),
          });
          setTimeout(() => {
            this.closeLoginDialog();
            this.currentUser = this.authenticationService.currentUserValue;
            if (this.currentUser) {
              // authorised so return true
              this.getUsername();
              this.getUserProfile();
            }
            // window.location.href = '/home';
            //this.router.navigate(['/home']);
          }, 1000);
        }
        localStorage.setItem('token', res.csrf_token);
        if (localStorage.getItem('language') === null) {
          localStorage.setItem('language', 'en');
        }
      },
      (err) => {
        if (err.status === 400) {
          // this.toastr.error('Incorrect username or password.', 'Authentication failed.');
          this.messageService.add({
            key: 'login',
            severity: 'error',
            summary: 'Error',
            detail: err.error.message,
          });
        } else {
          console.log(err);
        }
      }
    );
  }
  /**
   * searchByValue
   * @param selecedValue
   */
  searchByValue(selecedValue: any) {
    if (selecedValue && selecedValue !== '') {
      $('.mm-ocd--open').removeClass('mm-ocd--open');
      $('.mm-ocd-opened').removeClass('mm-ocd-opened');
      this.modelPopUp = false;
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/app-search', selecedValue]));
    }
  }

  searchByPage(selecedValue: any) {
    if (selecedValue && selecedValue.name !== '') {
      $('.mm-ocd--open').removeClass('mm-ocd--open');
      $('.mm-ocd-opened').removeClass('mm-ocd-opened');
      this.modelPopUp = false;
      if (selecedValue.description__value == 'category') {
        this.router.navigateByUrl(selecedValue.field_rest_path);
      } else {
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['/app-search', selecedValue.name]));
      }
    }
  }

  /**
   * showProfileDialog
   * will open the profile popup
   */
  showProfileDialog() {
    this.authDialogService.openProfileDialog();
    this.closeMenu();
  }

  /**
   * showChangePasswordDialog
   * will open the change password popup
   */
  showChangePasswordDialog() {
    this.authDialogService.openChangePasswordDialog();
    this.closeMenu();
  }

  /**
   * showLoginDialog
   * will open the login popup
   */
  showLoginDialog() {
    this.authDialogService.openLoginDialog();
    this.closeMenu();
  }

  /**
   * closeLoginDialog
   * will close the login popup
   */
  closeLoginDialog() {
    this.authDialogService.closeLoginDialog();
  }

  /**
   * showResetPasswordDialog
   * will open the reset password popup
   */
  showResetPasswordDialog() {
    this.authDialogService.openResetPasswordDialog();
    this.closeMenu();
  }

  /**
   * closeResetPasswordDialog
   * will close the reset password popup
   */
  closeResetPasswordDialog() {
    this.authDialogService.closeResetPasswordDialog();
  }

  /**
   * closeForgotPasswordDialog
   * will close the forgot password popup
   */
  closeForgotPasswordDialog() {
    this.authDialogService.closeForgotPasswordDialog();
  }

  /**
   * getUserProfile
   * get current user information like usermail
   */
  getUserProfile() {
    const userValue = this.authenticationService.currentUserValue;
    this.userid = userValue.current_user.uid;
    this.authenticationService.getUserProfile(this.userid).subscribe(
      (res) => {
        this.userMail = res.mail[0].value;
        if (
          res.field_country &&
          res.field_country[0] &&
          res.field_country[0].country &&
          res.field_country[0].country !== '' &&
          res.field_country[0].country !== null
        ) {
          const country = this.countries.find((val: any) => val.id == res.field_country[0].country);
          if (country) {
            this.userCountry = country.name;
          }
        }
        this.userProfile = res;
      },
      (err) => {
        if (err.error.message === 'Expired token') {
          this.authenticationService.logout().subscribe();
          //   setTimeout(() => {
          this.getUsername();
          this.currentUser = this.authenticationService.currentUserValue;
          if (this.currentUser) {
            this.getUserProfile();
          }
        }
      }
    );
  }
  /**
   * specialCategories
   * @param catName
   */
  specialCategories(catName: any) {
    var catNames = catName.title.toLowerCase();
    // if (catNames == 'workcation') {
    //   this.router.navigate(['/special_interest']);
    // } else {
    if (catNames == 'sustainable seychelles') {
      //this.router.navigate(['/special_interest/sustainability']);
      this.router.navigate(['/special_interest/sustainable_seychelles']);
    } else {
      this.router.navigate(['/special_interest/' + catNames]);
    }
    //}
    this.closeMenu();
  }

  /**
   * categories
   * @param refMenu
   */
  categories(refMenu: any) {
    if (refMenu.title == 'About Seychelles' || refMenu.title.toLowerCase() == 'about us') {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/aboutus', 'aboutseychelles']));
    } else if (refMenu.title == 'Travel Information' || refMenu.title.toLowerCase() == 'travel info') {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/travelinfo', 'travelinformation']));
    } else {
      this.titleService.setTitle(refMenu.title);
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/' + refMenu.route, refMenu.routeParam]));
    }
    this.closeMenu();
  }

  /**
   * activities
   * @param menu
   */
  activities(menu: any) {
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate(['/' + menu.route, menu.routeParam]));
  }

  whishList() {
    this.router.navigate(['/wishlist']);
  }

  islands(islands: any) {
    this.closeMenu();
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/islands'], {
        queryParams: { islandType: islands },
      })
    );
  }
  islandsDetails(view_node: string) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/island-details'], {
        queryParams: { view_node: view_node },
      })
    );
  }
  islandGroups(menu: any) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/island-groups'], {
        queryParams: { id: menu.id },
      })
    );
  }

  addpopup(title: string) {
    if (title == 'Search') {
      this.modelPopUp = true;
    }
  }
  closepopup() {
    this.modelPopUp = false;
  }

  click(menu: any) {
    this.menuitem = menu.toElement.innerText ? menu.toElement.innerText : 'MENU';
  }

  toggleMenu() {
    this.menuHidden = !this.menuHidden;
  }
  closeMenu() {
    $('.mm-ocd--open').removeClass('mm-ocd--open');
    $('.mm-ocd-opened').removeClass('mm-ocd-opened');
  }
  aboutUs(pageName: string) {
    if (pageName == 'About Seychelles' || pageName.toLowerCase() == 'about us') {
      pageName = 'aboutseychelles';
    }
    this.router
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.router.navigate(['/aboutus', pageName]));
    this.closeMenu();
  }
  travelInfo(menu: any) {
    if (menu.cat && menu.route && menu.routeParam) {
      this.router
        .navigateByUrl('/', { skipLocationChange: true })
        .then(() => this.router.navigate(['/' + menu.route, menu.routeParam]));
    } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/' + menu.url]));
    }
    this.closeMenu();
  }
  @HostListener('window:keydown', ['$event']) onMouseEnter(event: KeyboardEvent) {
    if (event.key === 'Enter' && this.modelPopUp) {
      this.searchByValue(this.searchQuery);
    }
  }
  search(events: any) {
    let event = events.query.toLowerCase().trim();
    this.searchQuery = event;
    this.refFilterResult = [];
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
    this.searchSub = this.searchService.getSearchInfo(event).subscribe((data) => {
      this.searchDetails = {};
      this.searchDetails = data;
      this.results = this.searchDetails.products;
      for (let i = 0; i < this.results.length; i++) {
        this.refFilterResult.push(this.results[i].productName);
        /*if (this.results[i].productNumber.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].productNumber);
        } else if (this.results[i].productCategoryId.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].productCategoryId);
        } else if (this.results[i].productDescription.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].productDescription.substr(0, 30) + '...');
        } else if (this.results[i].owningOrganisationId.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].owningOrganisationId);
        } else if (this.results[i].owningOrganisationName.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].owningOrganisationName);
        } else if (this.results[i].owningOrganisationNumber.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].owningOrganisationNumber);
        } else if (this.results[i].productId.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].productId);
        } else if (this.results[i].productName.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].productName);
        } else if (this.results[i].productPixelURL.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].productPixelURL);
        }
        if (this.results[i].addresses[0].address_type.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].addresses[0].address_type);
        } else if (this.results[i].addresses[0].address_line.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].addresses[0].address_line);
        } else if (this.results[i].addresses[0].islandType.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].addresses[0].islandType);
        } else if (this.results[i].addresses[0].island.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].addresses[0].island);
        } else if (this.results[i].addresses[0].country.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].addresses[0].country);
        } else if (this.results[i].addresses[0].state.toLowerCase().includes(event)) {
          this.refFilterResult.push(this.results[i].addresses[0].state);
        }*/
      }
      this.newserachResults = [];
      this.newserachResults = [...new Set(this.refFilterResult)];
    });
  }

  logout() {
    this.authenticationService.logout().subscribe(() => {
      // currentUser and username will be updated via the subscription
      this.messageService.add({
        key: 'logout',
        severity: 'success',
        summary: this.translate.instant('Success'),
        detail: this.translate.instant('LogOut-Success'),
      });
    });
  }

  getCountries() {
    this.searchService.getCountries().subscribe((data: any) => {
      this.countries = data.countries_list;
    });
  }

  getUsername() {
    const userValue = this.authenticationService.currentUserValue;
    if (userValue && userValue.current_user) {
      this.username = userValue.current_user.name;
      this.userLetter = this.getShortName(this.username);
      const credentials = this.credentialsService.credentials;
      return credentials ? credentials.username : null;
    } else {
      this.username = '';
    }
  }
  getShortName(fullName: any) {
    return fullName
      .split(' ')
      .map((n: any[]) => n[0])
      .join('');
  }
  goToProductDetails(val: any) {
    let product: any = { productId: '' };
    for (let i = 0; i < this.results.length; i++) {
      if (this.results[i].productName == val) {
        product = this.results[i];
        break;
      }
    }
    $('.mm-ocd--open').removeClass('mm-ocd--open');
    $('.mm-ocd-opened').removeClass('mm-ocd-opened');
    this.modelPopUp = false;
    if (product.productId == '') {
      this.router.navigate(['/app-search', val]);
    } else {
      this.router.navigate(['/listingdetails', product.productId]);
    }
  }
  getSearchDetails(selectedTerm: any) {
    this.modelPopUp = false;
    this.router.navigate(['/app-search', selectedTerm]);
  }
  private createChangePasswordForm() {
    this.changePasswordForm = this.formBuilder.group(
      {
        newpassword: new FormControl(null, Validators.required),
        oldPassword: new FormControl(null, Validators.required),
        confirmPassword: new FormControl(null, Validators.required),
      },
      {
        validator: this.matchPwds,
      }
    );
  }
  private createChangeUserNameForm() {
    this.changeUserNameForm = this.formBuilder.group({
      newUserName: ['', Validators.required],
      country: ['', Validators.required],
    });
    this.createAccountDeleteForm();
  }

  private createAccountDeleteForm() {
    this.accountDeleteForm = this.formBuilder.group({
      reason: ['', Validators.required],
    });
  }

  private createRegistrationForm() {
    this.registerForm = this.formBuilder.group({
      mail: new FormControl(null, [
        Validators.required,
        Validators.pattern(
          "^$|^([\\w-']+(?:\\.[\\w-']+)*)@((?:[\\w-]+\\.)*\\w[\\w-]+)\\.([a-zA-Z]+(?:\\.[a-zA-Z]+)?)$"
        ),
      ]),
      name: new FormControl(null, Validators.required),
      pass: new FormControl(null, Validators.required),
      country: new FormControl(null),
      confirm_pass: new FormControl(null, Validators.required),
      agreed: new FormControl('', Validators.required),
      subscribe: new FormControl(null),
    });
  }
  onSubmitRegistrationForm(): void {
    this.isLoading = true;
    const formValues = this.registerForm.value;
    if (formValues.country && formValues.country.id) {
      formValues['field_country'] = [{ country: formValues.country.id, locate: null }];
    }
    this.authenticationService.register(formValues).subscribe(
      (data) => {
        if (formValues.subscribe) {
          const data = {
            email: formValues.mail,
            firstName: formValues.name,
            country: formValues.country.name,
          };
          this.authenticationService.subscribeUser(data).subscribe();
        }
        this.isSuccessful = true;
        this.isLoading = false;
        this.isSignUpFailed = false;
        this.messageService.add({
          key: 'register',
          severity: 'success',
          summary: this.translate.instant('Success'),
          detail: this.translate.instant('Registration-Success'),
        });
        this.registrationDialog = false;
        // setTimeout(() => {
        //   this.router.navigate(['../login'], { relativeTo: this.route });
        // }, 2000);
      },
      (err) => {
        this.errorMessage = err.error.message;
        const errorMsgReplace = this.errorMessage.replace('Unprocessable Entity: validation failed.', ' ');
        this.isSignUpFailed = true;
        this.messageService.add({
          key: 'register',
          severity: 'error',
          summary: 'Error',
          // detail: err.error.message,
          detail: errorMsgReplace,
        });
      }
    );
    var mail = this.registerForm.value.mail;
    var subscription = this.registerForm.value.subscribe;
    if (mail && subscription) {
      this.subscribe(mail);
    }
  }
  subscribe(mail: any) {
    this.authenticationService.Usersubscribe(mail).then((res) => {
      this.subscribeRes = res;
    });
  }

  policy() {
    if (this.registerForm.value.agreed == 'true') {
      this.registerForm.value.agreed = true;
    } else {
      this.registerForm.value.agreed = false;
    }
  }
  matchPwds(control: AbstractControl) {
    let newPwd2 = control.get('newpassword');
    let confirmPwd2 = control.get('confirmPassword');
    if (newPwd2.value !== confirmPwd2.value) {
      return { pwdsDontMatch: true };
    }
    return null;
  }
  onSubmitChangePassword() {
    this.getUserProfile();
    this.authenticationService.changePassword(this.changePasswordForm.value, this.userProfile).subscribe(
      (res: any) => {
        this.messageService.add({
          key: 'changeuser',
          severity: 'success',
          summary: this.translate.instant('Success'),
          detail: this.translate.instant('Change-Password-Success'),
        });
        setTimeout(() => {
          this.changePasswordDialogue = false;
        }, 2000);
      },
      (err) => {
        if (err.status === 400) {
          this.messageService.add({
            key: 'changeuser',
            severity: 'error',
            summary: 'Error',
            detail: err.error.message,
          });
        } else if (err.status == 422) {
          this.messageService.add({
            key: 'changeuser',
            severity: 'error',
            summary: 'Error',
            detail: err.error.message,
          });
        } else {
          this.messageService.add({
            key: 'changeuser',
            severity: 'error',
            summary: 'Error',
            detail: err.error.message,
          });
        }
      }
    );
  }
  deleteUserConfirm() {
    this.confirmMessage = this.translate.instant('Are you sure?');
    this.confirmMessageSummary = this.translate.instant('Confirm to proceed');
    this.messageService.add({
      key: 'deleteUserProfile',
      sticky: true,
      severity: 'warn',
      summary: this.confirmMessage,
      detail: this.confirmMessageSummary,
    });
  }
  deleteUserProfile() {
    this.messageService.clear('deleteUserProfile');
    this.getUserProfile();
    this.authenticationService.deleteuserProfile(this.userid).subscribe(
      (res: any) => {
        if (res == null) {
          this.messageService.add({
            key: 'changeuser',
            severity: 'success',
            summary: this.translate.instant('Success'),
            detail: this.translate.instant('Delete-User-Success'),
          });
          setTimeout(() => {
            this.profileDialogue = false;
          }, 800);
          this.logout();
        }
      },
      (err) => {
        this.messageService.add({
          key: 'changeuser',
          severity: 'error',
          summary: 'Error',
          detail: err.error.message,
        });

        setTimeout(() => {
          this.profileDialogue = false;
        }, 2000);
      }
    );
  }
  /**
   * show hide passwors when clicking on eye icon
   */
  toggleOldPasswordType() {
    this.fieldOldPasswordType = !this.fieldOldPasswordType;
  }
  toggleNewPasswordType() {
    this.fieldNewPasswordType = !this.fieldNewPasswordType;
  }
  toggleConfirmPasswordType() {
    this.fieldConfirmPasswordType = !this.fieldConfirmPasswordType;
  }

  DisplayUsername() {
    this.showUsername = true;
    this.showUserCountry = false;
  }
  DisplayCountryname() {
    this.showUserCountry = true;
  }
  /**
   * change username submission
   */
  changeUserName() {
    this.getUserProfile();
    const formValues = this.changeUserNameForm.value;
    if (formValues.country && formValues.country.id) {
      formValues['field_country'] = [{ country: formValues.country.id, locate: null }];
    }
    this.authenticationService.changeUserName(this.changeUserNameForm.value, this.userProfile).subscribe(
      (res: any) => {
        let msg = 'Username and country changed successfully';
        let loginmsg = 'Login with new Username';
        let bool = true;
        if (
          this.changeUserNameForm.value.newUserName !== '' &&
          !(this.changeUserNameForm.value.country !== '' && this.changeUserNameForm.value.country !== null)
        ) {
          msg = 'Username changed successfully';
        }
        if (
          this.changeUserNameForm.value.newUserName == '' &&
          this.changeUserNameForm.value.country !== '' &&
          this.changeUserNameForm.value.country !== null
        ) {
          msg = 'Country changed successfully';
          loginmsg = 'Login again';
        }
        this.confirmMessage = this.translate.instant(msg);
        this.confirmMessageSummary = this.translate.instant(loginmsg);
        // this.messageService.clear();
        this.profileDialogue = false;
        this.messageService.add({
          key: 'c',
          sticky: true,
          severity: 'success',
          summary: this.confirmMessage,
          detail: this.confirmMessageSummary,
        });
        // setTimeout(() => {
        this.profileDialogue = false;
        // }, 2000)
      },
      (err) => {
        // if (err.status == 422) {
        this.messageService.add({
          key: 'changeuser',
          severity: 'error',
          summary: 'Error',
          detail: err.error.message,
        });
      }
      // }
    );
  }

  /**
   * deleteAccount
   */
  deleteAccount() {
    const formValues = this.accountDeleteForm.value;
    const req = {
      user_id: this.userid,
      reason: formValues.reason,
    };

    this.authenticationService.deleteAccount(req).subscribe(
      (res: any) => {
        this.profileDialogue = false;
        this.userAccountDeleteDialogue = false;
        this.messageService.add({
          key: 'changeuser',
          severity: 'success',
          summary: this.translate.instant('Success'),
          detail: this.translate.instant('Delete-User-Success'),
        });
        setTimeout(() => {
          this.profileDialogue = false;
          this.userAccountDeleteDialogue = false;
        }, 800);
        this.logout();
      },
      (err) => {
        this.messageService.add({
          key: 'changeuser',
          severity: 'error',
          summary: 'Error',
          detail: err.error.message,
        });
      }
    );
  }
  /**
   * confirm dialoge
   */
  onConfirm() {
    this.messageService.clear('c');
  }

  onReject() {
    this.messageService.clear('c');
    this.logout();
    // this.authenticationService.logout().subscribe();
    // //   setTimeout(() => {
    // this.messageService.add({
    //   key: 'logout',
    //   severity: 'success',
    //   summary: this.translate.instant('Success'),
    //   detail: this.translate.instant('LogOut-Success'),
    // });
  }
  onSubmitForgotForm(): void {
    //submit forgot password form
    // this.blocked = true;
    this.authenticationService.forgotPassword(this.forgotPassForm.value).subscribe(
      (res: any) => {
        // this.blocked = false;
        this.confirmMessage = this.translate.instant('Forgot-Password-Message');
        this.confirmMessageSummary = this.translate.instant('ForgotPWD-MSGSummary');
        this.messageService.add({
          key: 'forgotAlert',
          sticky: true,
          severity: 'success',
          summary: this.confirmMessage,
          detail: this.confirmMessageSummary,
        });
        this.closeForgotPasswordDialog();
      },
      (err) => {
        if (err.status === 400) {
          // this.blocked = false;
          this.messageService.add({
            key: 'forgot',
            severity: 'error',
            summary: 'Error',
            detail: err.error.message,
          });
        } else {
          // this.blocked = false;
          this.confirmMessage = this.translate.instant('Forgot-Password-Message');
          this.confirmMessageSummary = this.translate.instant('ForgotPWD-MSGSummary');
          this.messageService.add({
            key: 'forgotAlert',
            sticky: true,
            severity: 'success',
            summary: this.confirmMessage,
            detail: this.confirmMessageSummary,
          });
          this.closeForgotPasswordDialog();
        }
      }
    );
  }
  /**
   * on closing dialogue
   */
  onRejectForgotForm() {
    this.messageService.clear('forgotAlert');
    // this.router.navigate(['/login']);
  }
  private createForgotForm() {
    //create forgot password form
    this.forgotPassForm = this.formBuilder.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            "^$|^([\\w-']+(?:\\.[\\w-']+)*)@((?:[\\w-]+\\.)*\\w[\\w-]+)\\.([a-zA-Z]+(?:\\.[a-zA-Z]+)?)$"
          ),
        ],
      ],
    });
  }
  onSubmitResetPasswordForm() {
    //On submit Reset Password Form
    const currentUserValue = this.authenticationService.currentUserValue;
    if (currentUserValue) {
      this.currentUser = this.authenticationService.currentUser;

      //this.resetPasswordForm.value=
      this.authenticationService.resetPassword(this.resetPasswordForm.value, this.currentUser).subscribe(
        (res: any) => {
          this.confirmMessage = this.translate.instant('Change-Password-Success');
          this.confirmMessageSummary = this.translate.instant('Please-Login-ChangePWD-Summary');
          this.messageService.add({
            key: 'c',
            sticky: true,
            severity: 'success',
            summary: this.confirmMessage,
            detail: this.confirmMessageSummary,
          });
          this.closeResetPasswordDialog();
        },
        (err) => {
          if (err.status === 400) {
            this.messageService.add({
              key: 'logout',
              severity: 'error',
              summary: 'Error',
              detail: err.error.message,
            });
          } else {
            this.messageService.add({
              key: 'logout',
              severity: 'error',
              summary: 'Error',
              detail: err.error.message,
            });
          }
        }
      );
    } else {
      this.messageService.add({
        key: 'logout',
        severity: 'error',
        summary: this.translate.instant('Error'),
        detail: this.translate.instant('WrongWindow'),
      });
    }
  }
  /**
   * Onclose confirm box
   */
  onRejectResetPasswordForm() {
    this.messageService.clear('resetPassword');
    this.authenticationService.logout().subscribe();
    this.logout();
  }

  onRejectDeleteUser() {
    this.messageService.clear('deleteUserProfile');
  }
  /**
   * Creating Reset password form
   */
  private createResetForm() {
    //Reset Password form
    this.resetPasswordForm = this.formBuilder.group({
      tempPassword: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      confirmPassword: new FormControl(null, Validators.required),
    });
  }
  toggleTempPasswordType() {
    this.fieldTempPasswordType = !this.fieldTempPasswordType;
  }

  // To use for chatbot register click
  chatbotRegisterClick() {
    this.postMessageService.getMessage().subscribe((message) => {
      if (message.register) {
        this.authDialogService.openRegistrationDialog();
      }
    });
  }

  ngOnDestroy() {
    if (this.searchSub) {
      this.searchSub.unsubscribe();
    }
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }
}
